<app-watermark [isPhonePortrait]="isPhonePortrait" *ngIf="isPreview"></app-watermark>

<ng-container *ngIf="currentSection">
  <div class="section" >
    <div class="section-title" *ngIf="currentSection.sectionTitleText" [innerHTML]="currentSection.sectionTitleText | replacePatientTerm : currentSection.sectionTitle.patientTerms : this.sharedDataService.patientTerm | sanitizeHtml"  [ngClass]="{'is-phone-portrait': isPhonePortrait}">
    </div>
    <div class="section-description" *ngIf="currentSection.sectionDescriptionText" [innerHTML]="currentSection.sectionDescriptionText | replacePatientTerm : currentSection.sectionDescription.patientTerms : this.sharedDataService.patientTerm | sanitizeHtml" [ngClass]="{'is-phone-portrait': isPhonePortrait}">
    </div>
    <div class="section-question-header" *ngIf="currentSection.sectionQuestionHeaderText" [innerHTML]="currentSection.sectionQuestionHeaderText | replacePatientTerm : currentSection.sectionQuestionHeader.patientTerms : this.sharedDataService.patientTerm | sanitizeHtml" [ngClass]="{'is-phone-portrait': isPhonePortrait}">
    </div>
  </div>

  <!-- Loop over Questions in the Current Section -->
  <ng-container *ngFor="let question of questionsService.questionsInCurrentSection; let i = index;">
    <ng-container [ngSwitch]="question.responseType">
      
      <!-- ResponseType 1 / Vertical Radio Button -->
      <app-radio-button-vertical
        *ngSwitchCase="ResponseTypesEnum.RadioButtonVertical"
        [question]="question"
        [otherAnswerPlaceholder]="this.otherAnswerPlaceholderLocalized"
      />

      <!-- ResponseType 2 -->
      <ng-container *ngSwitchCase="ResponseTypesEnum.RadioButtonHorizontalWithHeader">
        <ng-container *ngIf="isPhonePortrait; else notPhonePortrait">
          <!-- Vertical Radio Button -->
          <app-radio-button-vertical
            [question]="question"
            [otherAnswerPlaceholder]="otherAnswerPlaceholderLocalized"
          />
        </ng-container>
        <ng-template #notPhonePortrait>
          <!-- Horizontal Radio Button -->
          <app-radio-button-horizontal
            [questions]="questionsService.questionsInCurrentSection"
            [index]="i" 
          />
        </ng-template>
      </ng-container>

      <!-- ResponseType 3 -->
      <ng-container *ngSwitchCase="ResponseTypesEnum.RadioButtonHorizontalWithoutHeader">
        <ng-container *ngIf="isPhonePortrait">
          <!-- Vertical Radio Button -->
          <app-radio-button-vertical
            [question]="question"
            [otherAnswerPlaceholder]="otherAnswerPlaceholderLocalized"
          />
        </ng-container>
      </ng-container>

      <!-- Response 4 / Text Box -->
      <app-answer-textbox 
        *ngSwitchCase="ResponseTypesEnum.Textbox"
        [question]="question"
      />

      <!-- ResponseType 5 / Drop Down -->
      <app-drop-down-list-answer
        *ngSwitchCase="ResponseTypesEnum.DropDownList"
        [question]="question"
        (dropDownSaved)="dropDownFirstQuestionSaved()"
        (dropDownValidation)="dropDownComponentValidation($event)"
      />
      
      <!-- Response 6 / Question With No Answer -->
      <app-question-no-answer
        *ngSwitchCase="ResponseTypesEnum.QuestionWithNoAnswers"
        [question]="question"
      />

      <!-- Response 7 / Skip Logic Question -->
      <app-skip-logic-question
        *ngSwitchCase="ResponseTypesEnum.SkipLogicQuestion"
        [question]="question" 
        [otherAnswerPlaceholder]="otherAnswerPlaceholderLocalized"
      />

    </ng-container>
  </ng-container>
  
  <div class="spinner">
    <mat-spinner mode="indeterminate" diameter="30" color="accent" value="25" *ngIf="isQuestionSaving"></mat-spinner>
  </div>
  <div class="button-indent">
    <button data-test-id="questionnaireBackButton" mat-raised-button (click)="GoPreviousPage()" color="primary"
      i18n="Back Button|Button to navigate to previous section of questions@@questionnaireBackButton">
      <mat-icon class="white-icon">west</mat-icon>Back</button>
    <button #nextButton id="nextButton" data-test-id="questionnaireNextButton" mat-raised-button (click)="GoNextPage(nextButton)"
      *ngIf="currentSection.sectionName"
      [disabled]="!checkSectionQuestionCompleteness() && !isPreview"
      [hidden]="hideNextButtonEnableSubmit()" color="primary"
      i18n="Next Button|Button used to move to the next page or section of questions@@questionnaireNextButton"><mat-icon
        class="white-icon" iconPositionEnd>east</mat-icon>Next</button>
    <button id="submitButton" data-test-id="questionnaireSubmitButton" mat-raised-button (click)="GoFinalPage()"
      [disabled]="this.questionnaireProgressCount() !== 1 || isPreview && !isQuestionSaving"
      [hidden]="!hideNextButtonEnableSubmit()" color="accent"
      i18n="Submit Button|Button to submit finalized questionnaire@@submitQuestionnaireButton"><mat-icon
        class="white-icon">done</mat-icon>SUBMIT</button>
    <button data-test-id="questionnaireSaveContinueLaterButton" mat-stroked-button (click)="saveContinueLater()"
      color="accent" class="saveButCls"
      i18n="Save and Continue Later Button|Button to diaplay dialog to copy questionnaire link to continue progress later@@questionnaireSaveContinueLaterButton"><b>SAVE
        & CONTINUE LATER</b></button>
  </div>
</ng-container>